import type { SVGProps } from "react";

export function IconBlackPeople2(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="6.25"
        cy="6.5"
        r="3.5"
        fill="#0B0C17"
        stroke="#0B0C17"
        strokeWidth="1.5"
      />
      <circle
        cx="17.75"
        cy="6.5"
        r="3.5"
        fill="#0B0C17"
        stroke="#0B0C17"
        strokeWidth="1.5"
      />
      <path
        d="M10.5 14.5H2V20H10.5V14.5Z"
        fill="#0B0C17"
        stroke="#0B0C17"
        strokeWidth="1.5"
      />
      <path
        d="M22 14.5H13.5V20H22V14.5Z"
        fill="#0B0C17"
        stroke="#0B0C17"
        strokeWidth="1.5"
      />
    </svg>
  );
}
